import { useRef as e, useState as o, useEffect as a } from "react";
const l = (c) => {
  const u = e(c), r = e(), t = e(!1), n = e(!1), [, f] = o(0);
  t.current && (n.current = !0), a(() => (t.current || (r.current = u.current(), t.current = !0), f((s) => s + 1), () => {
    n.current && r.current && r.current();
  }), []);
};
export {
  l as useEffectOnce
};
